module.exports = __webpack_public_path__ + "static/media/GB.345d29b7.svg";